import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgResults = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.25 5c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v6.238a.75.75 0 0 1-1.5 0V5a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h5.476a.75.75 0 0 1 0 1.5H5A1.75 1.75 0 0 1 3.25 19zM9 8a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 9 8m0 3.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m-2-.75A.75.75 0 0 0 7 12h.01a.75.75 0 0 0 0-1.5zM6.25 14a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M7 7.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm10.213 5.518a.75.75 0 0 0-1.426 0l-.842 2.591H12.22a.75.75 0 0 0-.44 1.357l2.204 1.602-.842 2.59a.75.75 0 0 0 1.154.84l2.204-1.602 2.204 1.601a.75.75 0 0 0 1.154-.838l-.842-2.591 2.205-1.602a.75.75 0 0 0-.441-1.357h-2.725zm-1.01 3.573.297-.914.297.914a.75.75 0 0 0 .713.518h.961l-.777.565a.75.75 0 0 0-.273.839l.297.914-.777-.565a.75.75 0 0 0-.882 0l-.777.565.297-.914a.75.75 0 0 0-.273-.839l-.777-.565h.96a.75.75 0 0 0 .714-.518"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgResults;
